export const headerLinks = [
  {id: 1, name: 'about_me', defaultMessage: 'About me', link: 'Acquaintence'},
  {id: 2, name: 'relationships', defaultMessage: 'Relationship', link: 'IAmDeveloper'},
  {id: 3, name: 'requirements', defaultMessage: 'Requirements', link: 'Requirements'},
  {id: 4, name: 'users', defaultMessage: 'Users', link: 'ShowUsers'},
  {id: 5, name: 'sign_up', defaultMessage: 'Sign Up', link: 'FormValidation'},
  {id: 6, name: 'footer', defaultMessage: 'Footer', link: 'Footer'}
]

export const languages = [
  {id: 1, name: 'EN'},
  {id: 2, name: 'RU'},
  {id: 3, name: 'UA'}
]